<template>
  <!--普通模板-->
  <div class="general">
    <!--授权模板-->
    <template v-if="isShowAuthorizationList">
      <div class="sp">
        <h1 class="com-title com-ht">
          <i></i>授权给我的模板<span style="font-size: 14px">
            / 当前用户的权限范围可使用的模板</span
          >
        </h1>
        <div class="search">
          <el-input
            v-model="templateName"
            placeholder="请输入模板名称"
            size="mini"
            clearable
          ></el-input>
          <el-button
            size="mini"
            @click="serchTemplate(templateName)"
            type="primary"
            icon="el-icon-search"
            class="searchIcon"
          ></el-button>
        </div>
      </div>
      <div class="box-wrap">
        <div
          class="temone"
          v-for="(item, index) in authorizationList"
          :key="index"
        >
          <div class="t-box">
            <img class="y-img" src="/images/web/ye.png" />
            <p>{{ item.tplName }}</p>
          </div>

          <template v-if="isAdVn(item)">
            <div class="b-box">
              <nuxt-link
                class="a-btn"
                :to="{
                  path: '/advancedVersion/writeVariables',
                  query: { id: item.tplId }
                }"
                :style="item.signerFixed ? 'width:100%' : ' width:50%'"
                >立即发起
              </nuxt-link>
              <a
                class="a-btn"
                @click="(plDialogVisible = true), (batchTplId = item.tplId)"
                v-if="!item.signerFixed"
                >批量发起</a
              >
            </div>
          </template>
          <template v-else>
            <nuxt-link
              class="a-btn"
              :to="{
                path: '/tpl/add/apply',
                query: { tplId: item.tplId, isAuth: 1 }
              }"
              >立即使用</nuxt-link
            >
          </template>
        </div>
        <no-data
          text="企业暂未授权模板给您，如需使用请联系管理员"
          style="margin-top: 30px;"
          v-if="!authorizationList.length"
        />
      </div>
    </template>

    <goto-auth :authDialog.sync="authDialog"></goto-auth>

    <!--批量发起弹窗-->
    <batch-launch
      v-if="plDialogVisible"
      :show.sync="plDialogVisible"
      :tplId="batchTplId"
    />
  </div>
</template>

<script>
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import { listSystemTemplate } from "@/assets/js/http-serve/http-sysTpl";
import ElGo from "@/components/go/Go";
import BatchLaunch from "@/components/advancedVersion/batchLaunch";
import switchButton from "@/components/switch-button/index";
import { mapGetters } from "vuex";
export default {
  components: { ElGo, BatchLaunch, switchButton },
  data() {
    return {
      paged: { itemPage: 1, pageSize: 9999 },
      loadingList: false,
      dataList: [], // 我的模板
      apiTemplateList: [], // api模板
      authorizationList: [], // 授权给我的模板
      authDialog: false,
      templateName: "", //模板名称（搜索）
      // 批量发起
      plDialogVisible: false,
      batchTplId: null
    };
  },
  methods: {
    //我的模板编辑
    modulesEditFn(item) {
      if (this.$store.getters.authUser.identityAuth > -1) {
        //是否是高级用户
        if (this.whetherSeniorUser) {
          switch (item.tplVersion) {
            case 1:
              this.$router.push({
                // path: "/console/authEdit",
                path: item.editorType ? "/authEdit/variableEditor" : "/console/authEdit", //替换新编辑器地址-1903
                query: { tplId: item.tplId }
              });
              break;
            case 2:
              this.$router.push({
                path: "/advancedVersion/addTpl",
                query: { id: item.tplId }
              });
              break;
            default:
              this.$router.push({
                // path: "/tpl/add/general",
                path: item.editorType ? "/authEdit/variableEditor" : "/tpl/add/general", //替换新编辑器地址-1903
                query: { tplId: item.tplId}
              });
              break;
          }
        } else {
          this.$router.push({
            // path: "/tpl/add/general",
            path: item.editorType ? "/authEdit/variableEditor" : "/tpl/add/general", //替换新编辑器地址-1903
            query: { tplId: item.tplId}
          });
        }
      } else {
        this.authDialog = true;
      }
    },
    //我的模板立即使用
    templateUseFn: function(item) {
      if (item.tplVersion === 2 && item.status === 1) {
        return this.$message.warning("模板未完成，请发布后使用");
      }
      if (this.whetherSeniorUser) {
        switch (item.tplVersion) {
          case 1:
            this.$router.push({
              path: "/tpl/add/apply",
              query: { tplId: item.tplId, isAuth: 1 }
            });
            break;
          case 2:
            this.$router.push({
              path: "/advancedVersion/writeVariables",
              query: { id: item.tplId }
            });
            break;
          default:
            this.$router.push({
              path: "/tpl/add/apply",
              query: { tplId: item.tplId }
            });
            break;
        }
      } else {
        this.$router.push({
          path: "/tpl/add/apply",
          query: { tplId: item.tplId }
        });
      }
    },
    //添加模板按钮
    templateAddChoose: function(val) {
      if (this.$store.getters.authUser.identityAuth > -1) {
        val
          ? this.$router.push({ path: "/advancedVersion/addTpl" })
          : this.$router.push({
            // path: "/tpl/add/general"
            path: "/authEdit/variableEditor", //替换新编辑器地址-1903
          });
      } else {
        this.authDialog = true;
      }
    },
    //二次确认函数
    seccondConfirmFn: function(switchVal, object) {
      return new Promise((resolve, reject) => {
        if (switchVal) {
          ApiMethods.TemplateController.allowMemberUseTem({
            tplId: object.tplId,
            tplVersion: object.tplVersion
          }).then(res => {
            if (res.success && res.code === "0") {
              resolve();
              this.$confirm("开启成功，是否前往授权？", "系统提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  this.$router.push({
                    // path: "/console/setting?activeName=tab-template"
                    path: "/console/template"
                  });
                })
                .catch(() => {});
            } else {
              this.$message.error(res.description || res.msg);
            }
          });
        } else {
          this.$confirm(
            "关闭之后授权的组织成员将无法使用该模板，已发起的合同不受影响，是否继续?",
            "系统提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
            .then(async () => {
              //prohibitMemberUserTem关闭成员使用模板
              let res = await ApiMethods.TemplateController.prohibitMemberUserTem(
                {
                  tplId: object.tplId,
                  tplVersion: object.tplVersion
                }
              );
              if (res.success && res.code === "0") {
                resolve();
                this.$message.success("关闭成功");
              } else {
                this.$message.error(res.description || res.msg);
              }
            })
            .catch(() => {});
        }
      });
    },
    templateDelFn: async function(target) {
      let param = { tplId: target.tplId };
      let result = "";
      if (this.whetherSeniorUser) {
        switch (target.tplVersion) {
          case 1:
            result = await ApiMethods.TemplateController.delTplV1(param);
            break;
          case 2:
            result = await ApiMethods.TemplateController.delTplV2(param);
            break;
          default:
            result = await ApiMethods.TemplateController.delTpl(param);
            break;
        }
      } else {
        result = await ApiMethods.TemplateController.delTpl(param);
      }
      if (result.success) {
        this.$alert("操作成功", "系统提示", {
          confirmButtonText: "确定",
          callback: action => {
            this.queryList(this.templateName);
          }
        });
      } else {
        this.$message.error(result.description || this.$tip);
      }
    },
    delTpl: function(target) {
      var _this = this;
      _this
        .$confirm(
          "删除之后，该模板将彻底消失，授权的组织成员将无法使用该模板，已发起的合同不受影响，是否继续？",
          "系统提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
        .then(() => {
          this.templateDelFn(target);
        })
        .catch(() => {});
    },
    handleCurrentChange: function(val) {
      this.paged.pageNum = val;
      this.queryList(this.templateName);
    },
    handleSizeChange: function(val) {
      this.paged.pageSize = val;
      this.queryList(this.templateName);
    },
    /**
     *  我的模板
     * */
    queryList(name) {
      let param = {
        itemPage: this.paged.pageNum,
        pageSize: this.paged.pageSize,
        tplName: name
      };
      this.loading = true;
      ApiMethods.TemplateController.listTpl(param)
        .then(result => {
          if (result.success) {
            this.dataList = result.data;
            this.paged = {
              pageNum: result.pageNum,
              pageSize: result.pageSize,
              pages: result.pages,
              total: result.total
            };
          } else {
            if (this.$store.getters.authUser.identityAuth > -1)
              this.$message.error(result.description || this.$tip);
            return;
          }
        })
        .finally(() => {
          this.loadingList = false;
        });
    },
    /**
     *  api模板
     * */
    apiList: function(name) {
      let param = {
        ...this.paged,
        // tplGroupTypeId:this.operGroupType.tplGroupTypeId
        tplName: name
      };
      ApiMethods.ApiTemplateController.listTpl(param)
        .then(result => {
          if (result.success) {
            this.apiTemplateList = result.data;
          } else {
            this.$message.error(result.description || this.$tip);
          }
        })
        .finally(() => {
          // this.loading = false;
        });
    },
    /**
     *  删除api模板
     * */
    delApiTpl: function(target) {
      var _this = this;
      _this
        .$confirm("此操作将永久删除该模板, 是否继续?", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          var param = { tplId: target.tplId };
          ApiMethods.ApiTemplateController.delTpl(param).then(result => {
            if (result.success) {
              _this.$alert("操作成功", "系统提示", {
                confirmButtonText: "确定",
                callback: action => {
                  _this.apiList(_this.templateName);
                }
              });
            } else {
              _this.$alert(result.description || "操作失败", "系统提示");
            }
          });
        })
        .catch(() => {});
    },
    /**
     *  授权给我的模板
     * */
    queryAuthorizationList(name) {
      const param = { ...this.paged, tplName: name };
      ApiMethods.TemplateController.authTpl(param)
        .then(result => {
          if (!result.success)
            return this.$message.error(result.description || this.$tip);
          this.authorizationList = result.data;
          // console.log(result.data);
        })
        .finally(() => {
          // this.loadingList = false
        });
    },

    // 当前是否高级模板
    isAdVn(item) {
      return +item.tplVersion === 2;
    },
    // 搜索模板
    serchTemplate(name) {
      this.queryList(name);
      this.isShowAuthorizationList && this.queryAuthorizationList(name);
    }
  },
  computed: {
    ...mapGetters(["currentAuthUser"]),
    //是否是高级企业用户
    whetherSeniorUser() {
      let currentAuthUser = this.currentAuthUser;
      let allAuthUser = this.$store.getters.allAuthUser;
      //判断是不是普通账号（超级管理员绑定在普通账号）true: 高级用户
      return (
        currentAuthUser &&
        currentAuthUser.userType == 1 &&
        allAuthUser &&
        allAuthUser.corpCreateFlag == 1
      );
    },
    /**
     *  是否显示授权模板
     * */
    isShowAuthorizationList() {
      if (
        this.currentAuthUser &&
        (this.currentAuthUser.userType == 1 ||
          this.currentAuthUser.superFlag !== undefined) &&
        this.currentAuthUser.superFlag !== undefined
      ) {
        return true;
      }
      return false;
    }
  },
  watch: {
    isShowAuthorizationList(newValue) {
      this.queryAuthorizationList(this.templateName);
    }
  },
  created() {
    this.isShowAuthorizationList &&
      this.queryAuthorizationList(this.templateName);
  },
  name: "general"
};
</script>

<style lang="less" scoped>
.general {
  min-height: 76vh;
  overflow-x: hidden;
  overflow-y: auto;
  max-width: 1200px;
  margin: 0 auto;
}
@tem-width:175px;
.box-wrap {
  display: grid;
  grid-template-columns: repeat(auto-fill, @tem-width);
  align-items: flex-start;
  justify-items:center;
  justify-content: space-around;
  padding: 15px 20px;

  &:last-child {
    margin-bottom: 130px;
  }
  .temone {
    width: @tem-width;
    margin-bottom: 20px;
    text-align: center;
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 4px;
    &.add {
      cursor: pointer;
      height: 140px;
      line-height: 140px;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
      }
    }
    &.temone-center {
      height: 160px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .t-box {
        width: 100%;
        height: 75%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        overflow: hidden;
        .y-img {
          margin-top: 0;
        }
      }
      .tpid {
        width: 100%;
        height: 32%;
        background: #eeeeee;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .temone_switch {
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 12px;
      padding-bottom: 10px;
    }
    .t-box {
      position: relative;
      height: 105px;
      overflow: hidden;
      &:hover {
        .msk {
          width: 100%;
          height: 100%;
          opacity: 1;
        }
      }
      .y-img {
        width: 46px;
        height: 54px;
        display: block;
        margin: 17px auto 7px auto;
      }
      p {
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0 10px;
        width: 100%;
        font-family: Source Han Sans SC;
        color: rgba(41, 2, 2, 0.65);
        box-sizing: border-box;
      }
      .msk {
        transition: all ease 0.2s;
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 0;
        background: rgba(0, 0, 0, 0.5);
        opacity: 0;
        padding: 8px 8px;
        box-sizing: border-box;
        span {
          cursor: pointer;
          float: right;
          color: #ffffff;
          font-size: 20px;
          margin-left: 10px;
          &:hover {
            color: rgba(236, 28, 28, 1);
          }
        }
      }
    }

    .b-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      a {
        width: 50%;
      }
    }
    .el-icon-plus {
      cursor: pointer;
      color: #c9bfbf;
      font-size: 80px;
    }
  }
}

.a-btn {
  cursor: pointer;
  display: block;
  width: 100%;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: rgba(41, 2, 2, 1);
  text-decoration: none;
  border-radius: 0px 0px 4px 4px;
  background: rgba(239, 239, 239, 1);
  &:hover {
    color: rgba(236, 28, 28, 1);
    /*background:rgba(236,28,28,1);*/
  }
}

.search {
  display: flex;
  align-items: center;
  margin-right: 20px;
  border-radius: 4px;

  /deep/ .el-input__inner {
    border-radius: 4px 0 0 4px;
  }
  .searchIcon {
    padding: 7px 10px;
    border-radius: 0 3px 3px 0;
    background: rgb(222, 219, 220);
    border: 1px solid rgb(222, 219, 220);

    &:hover {
      background: #ec1c1c;
      border: 1px solid #ec1c1c;
    }
  }
}

.sp {
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .com-ht {
    border-bottom: none;
  }
}
</style>



// WEBPACK FOOTER //
// components/console/template/tempMe.vue